module.exports = __webpack_public_path__ + "img/cotuongvn-avatar.9a54cb85.png";